import request from '@/api/config/request'

const prex = "api/painel/";

export function getPainelBase(eco_codigo) {
    return request({
        url: `${prex}${eco_codigo}`,
        method: 'get',
    })
}